import { useState } from 'react'
import { IApplicationState } from 'Store/types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import DadCAppBar from './AppBar/AppBar'
import DadCBottomNavigation from './BottomNavigation/BottomNavigation'
import AppRouter from 'Routes/AppRouter'
import DrawerMenu from './DrawerMenu/DrawerMenu'
import { useLocation } from 'react-router-dom'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'

const Main = () => {
  const [t] = useTranslation()
  const location = useLocation()
  const { drawerVisible } = useSelector((store: IApplicationState) => store.common)
  const dispatch = useDispatch()

  return (
    <div id="wrapper" className={`group ${drawerVisible ? 'show-asidemenu' : ''}`}>
      <div className="hidden lg:flex flex-col gap-2 fixed top-1/2 -translate-y-1/2 right-[calc(2.5rem+85px)]">
        <img src="./assets/images/logoDiffColor.svg" width="85" />
        {/* <img src="./assets/images/logo-text.svg" width="85" /> */}
      </div>

      <main>
        <AppRouter />
        {location.pathname.toLocaleLowerCase() != VisitsPaths.NewVisit.toLocaleLowerCase() &&
          location.pathname.toLocaleLowerCase() !=
            VisitsPaths.SendToServerPage.toLocaleLowerCase() &&
          !location.pathname
            .toLocaleLowerCase()
            .startsWith(VisitsPaths.IncompleteDocumentationPage.toLocaleLowerCase()) &&
          !location.pathname.startsWith('/Visits/Edit') &&
          !location.pathname.startsWith('/Notification') && <DadCBottomNavigation />}
      </main>
      <div className="backdrop group-[.show-asidemenu]:opacity-100 group-[.show-asidemenu]:pointer-events-auto group-[.show-bottomsheet]:opacity-100 group-[.show-bottomsheet]:pointer-events-auto"></div>
    </div>
  )
}

export default Main
